<template>
  <div class="MoreInfo">

    <h3>
      Vad är MIK?
    </h3>
    <p>
      MIK står för medie- och informationskunnighet: att kunna hantera, värdera och analysera det informationsflöde som förekommer via olika medietyper. Det handlar om allt ifrån digital källkritik och reklamkunnighet till filmanalys och datorspel. MIK handlar om alla människors rätt till information och kunskap: kort och gott en demokratifråga.
    </p>

    <h3>
      Vad är ett jam?
    </h3>

    <p>
      Under ett jam samlas människor från olika bakgrunder för att skapa tillsammans. MIK-jam pågår normalt under en heldag, och fokus är på att ha roligt, lära sig, och inspireras av varandra.
    </p>

  </div>
</template>

<script>

//import { store } from '@/store';
//import Component from '@/components/Component'

export default {
  name: 'MoreInfo',
  /*components: {
    Component
  },*/
  data () {
    return {
    }
  },
  props: {
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style scoped>

.MoreInfo{
}

</style>



// WEBPACK FOOTER //
// src/components/ShortInfo.vue